/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Segment_PrefixInputs */



/**
* | output |
* | --- |
* | "Segment" |
*
* @param {Segment_Event_Group_Segment_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_segment_prefix = /** @type {((inputs?: Segment_Event_Group_Segment_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Segment_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segment")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segment")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегмент")
	if (locale === "es") return /** @type {LocalizedString} */ ("Segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("部分")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Segmento")
	return /** @type {LocalizedString} */ ("Segment")
});